import { BaseBlockProps } from '../../defs/block';

export type BigEggBlockID = 'bigEgg';

export type BigEggBlockType = 'bigEgg';

export type BigEggBlockProps = {
  type: BigEggBlockType;
} & BaseBlockProps;

export const bigEggBlockProps: Record<BigEggBlockID, BigEggBlockProps> = {
  bigEgg: {
    id: 'be',
    type: 'bigEgg',
    immobile: true,
    generator: true,
    goalCountMultiplier: 6,
    width: 2,
    height: 2,
    options: [
      { count: 7 },
      { count: 6 },
      { count: 5 },
      { count: 4 },
      { count: 3 },
      { count: 2 },
      { count: 1 },
    ],
    optionType: 'list',
  },
};
